import { render, staticRenderFns } from "./StudentsWithPhoto.vue?vue&type=template&id=65c17cd2&scoped=true&"
import script from "./StudentsWithPhoto.vue?vue&type=script&lang=js&"
export * from "./StudentsWithPhoto.vue?vue&type=script&lang=js&"
import style0 from "./StudentsWithPhoto.vue?vue&type=style&index=0&id=65c17cd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c17cd2",
  null
  
)

export default component.exports